import { CompositionConfig } from '../types/RemotionPlayerConfigTypes/CompositionConfig';
import { CompositeSegment } from '../types/RemotionPlayerConfigTypes/Segment/CompositeSegment';
import { VideoSegment } from '../types/RemotionPlayerConfigTypes/Segment/VideoSegment';
import { CaptionsTrack } from '../types/RemotionPlayerConfigTypes/Track/CaptionsTrack/CaptionsTrack';
import { ElementsTrack } from '../types/RemotionPlayerConfigTypes/Track/ElementsTrack';
import { SegmentsTrack } from '../types/RemotionPlayerConfigTypes/Track/SegmentsTrack';
import { SegmentType } from '../types/Segment/Type';
import { TrackType } from '../types/Track/Type';

export const getSegmentsTrack = (playerConfig: CompositionConfig) => {
  return playerConfig?.playerConfig?.tracks?.find(track => track.type === TrackType.SEGMENTS) as SegmentsTrack;
};
// !! TODO @HiteshChoudhary0098 remove this function cause it will cause confusion with splits. Should return array of composite segments

export const getCompositeSegment = (playerConfig: CompositionConfig) => {
  const trackSegments = getSegmentsTrack(playerConfig);
  const compositeSegment = trackSegments?.segments?.find(
    segment => segment.type === SegmentType.COMPOSITE
  ) as CompositeSegment;

  return compositeSegment;
};

export const getCaptionsTrack = (playerConfig: CompositionConfig | null) => {
  const captionsTrack = playerConfig?.playerConfig?.tracks?.find(track => track.type === TrackType.CAPTIONS) as
    | CaptionsTrack
    | undefined;

  return captionsTrack;
};
export const getPlayerConfigIntro = (playerConfig: CompositionConfig) => {
  const segmentTracks = playerConfig?.playerConfig.tracks.find(
    track => track.type === TrackType.SEGMENTS
  ) as SegmentsTrack;
  const videoSegments = segmentTracks?.segments.filter(segment => segment.type === SegmentType.VIDEO) as VideoSegment[];

  return videoSegments?.find(segment => segment.id === 'intro');
};

export const getPlayerConfigOutro = (playerConfig: CompositionConfig) => {
  const segmentTracks = playerConfig?.playerConfig.tracks.find(
    track => track.type === TrackType.SEGMENTS
  ) as SegmentsTrack;
  const videoSegments = segmentTracks?.segments.filter(segment => segment.type === SegmentType.VIDEO) as VideoSegment[];

  return videoSegments?.find(segment => segment.id === 'outro');
};

export const getPlayerConfigElements = (playerConfig: CompositionConfig | null) => {
  if (!playerConfig) {
    return [];
  }

  return playerConfig?.playerConfig.tracks.filter(track => track.type === TrackType.ELEMENTS) as ElementsTrack[];
};
